import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { odhlasitPush } from "../lib/push";
import { nastavFaze } from "../lib/faze";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking
  const [company, setCompany] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/api/auth/me");
      nastavFaze(data.company?.faze_nastaveni);   // vlastní názvy fází a mezikroky firmy
      setUser(data.user);
      setCompany(data.company);
      return data.user;
    } catch (e) {
      setUser(null);
      setCompany(null);
      return null;
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    await api.post("/api/auth/login", { email, password });
    return loadMe();
  };

  const register = async (payload) => {
    await api.post("/api/auth/register", payload);
    return loadMe();
  };

  const logout = async () => {
    await odhlasitPush();
    try {
      await api.post("/api/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setUser(null);
    setCompany(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, company, setCompany, setUser, login, register, logout, loadMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
